import React from 'react';
import {
  ReceiptLong as ReceiptLongIcon,
  PersonOutline,
  Hotel,
  History,
  MedicalServices,
} from '@mui/icons-material';

import DepartmentLayout from '../Layout/DepartmentLayout';
import Home from './Home';
import OutPatient from './OutPatient';
import InPatient from './InPatient';
import MedicalHistoryPage from './MedicalHistoryPage';

// Menu config — `key` MUST match the `component_name` registered in the DB
// for permission filtering. To add a new section, just add an entry here.
const MENU_ITEMS = [
  { key: 'Home',                label: 'Home',            icon: <ReceiptLongIcon />, component: Home },
  { key: 'OutPatient',          label: 'OutPatient',      icon: <PersonOutline />,    component: OutPatient },
  { key: 'InPatient',           label: 'InPatient',       icon: <Hotel />,            component: InPatient },
  { key: 'MedicalHistoryPage',  label: 'Medical History', icon: <History />,          component: MedicalHistoryPage },
];

export default function Doctors() {
  return (
    <DepartmentLayout
      departmentId={3}
      departmentName="General Medical Service"
      departmentIcon={<MedicalServices />}
      menuItems={MENU_ITEMS}
    />
  );
}
